import React, { useEffect } from "react";
import "./Delete_Modal.css";
import { Button, Modal } from "react-bootstrap";
import Delete_Lottie from "./Delete_Lottie/Delete_Lottie";

function Delete_Modal(props) {
  const { message, subMessage } = props; // Extracting 'message' prop

  console.log(props,'props');
  

   useEffect(() => {
        setTimeout(() => {
            props.onHide();
        }, 3000);
    },[props.show]);
  return (
    <>
      <div className="Delete_Modal_sec">
        <Modal
          className="Delete_Modal"
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="lottie-holder">
              {" "}
              <Delete_Lottie />
            </div>
            <div className="text-center">
              <p>{message}</p> {/* Displaying the 'message' prop */}
              <sub>{subMessage}</sub>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Delete_Modal;
